var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_691_1714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 103C88.5097 103 110 81.5097 110 55C110 28.4903 88.5097 7 62 7C35.4903 7 14 28.4903 14 55C14 81.5097 35.4903 103 62 103Z",
    fill: "url(#paint0_linear_691_1714)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9988 101.431C87.6417 101.431 108.429 80.6436 108.429 55.0008C108.429 29.358 87.6417 8.57031 61.9988 8.57031C36.356 8.57031 15.5684 29.358 15.5684 55.0008C15.5684 80.6436 36.356 101.431 61.9988 101.431Z",
    fill: "#6F5C91"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_691_1714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8114 29.9731H70.2669L67.0645 33.1773C66.2351 34.0074 66.2362 35.3519 67.0673 36.1809C67.8967 37.0076 69.2432 37.0093 70.0736 36.1781L76.8936 29.3542C77.7346 28.5131 77.7235 27.131 76.8449 26.3048L70.0736 19.5296C69.2443 18.6995 67.8983 18.6984 67.0673 19.5268C66.2362 20.3558 66.2351 21.7002 67.0645 22.5303L70.258 25.7258C60.6238 25.7258 61.8253 25.7252 61.7201 25.7252C39.2444 25.7252 24.9777 50.1588 36.248 69.7981C36.8315 70.8151 38.1299 71.1679 39.1497 70.5845C40.1684 70.001 40.5206 68.7036 39.937 67.686C30.2375 50.7842 42.6532 29.8768 61.8114 29.9731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2487 40.5052C86.6652 39.4882 85.3657 39.1359 84.347 39.7188C83.3283 40.3022 82.9762 41.6002 83.5603 42.6178C93.1861 59.3913 81.0372 80.3308 61.7478 80.3308H53.2298L56.4322 77.1265C57.2621 76.2964 57.261 74.952 56.43 74.123C55.5989 73.2945 54.2524 73.2956 53.4231 74.1257L46.6031 80.9496C45.7693 81.7836 45.7649 83.1678 46.6546 84.0018L53.4231 90.7742C54.2524 91.6038 55.5984 91.606 56.43 90.777C57.261 89.948 57.2621 88.6036 56.4327 87.7735L53.2393 84.5781H61.7744C84.2617 84.5775 98.5167 60.1406 87.2487 40.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6223 48.7758H68.1264C69.3002 48.7758 70.2525 47.8246 70.2525 46.6522C70.2525 45.4792 69.3002 44.5285 68.1264 44.5285H63.8743V42.4049C63.8743 41.2319 62.9221 40.2812 61.7483 40.2812C60.574 40.2812 59.6223 41.2319 59.6223 42.4049V44.5285C56.1049 44.5285 53.2441 47.3866 53.2441 50.8995C53.2441 54.4123 56.1049 57.2704 59.6223 57.2704H63.8738C65.0464 57.2704 66.0004 58.2227 66.0004 59.3941C66.0004 60.5654 65.052 61.5183 63.8738 61.5183C61.6769 61.5183 61.7483 61.5177 61.7483 61.5177C61.745 61.5177 61.7417 61.5183 61.7383 61.5183C61.6558 61.5183 55.3226 61.5177 55.3702 61.5177C54.1959 61.5177 53.2441 62.4684 53.2441 63.6408C53.2436 64.8138 54.1953 65.7645 55.3696 65.765H59.6223V67.8887C59.6223 69.0611 60.574 70.0123 61.7483 70.0123C62.9221 70.0123 63.8743 69.0611 63.8743 67.8887V65.7656C67.3989 65.7656 70.2525 62.9169 70.2525 59.3941C70.2525 55.8812 67.3906 53.0231 63.8738 53.0231H59.6223C58.4496 53.0231 57.4962 52.0703 57.4962 50.8995C57.4962 49.7282 58.4496 48.7758 59.6223 48.7758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_691_1714",
    x: 0.498819,
    y: 0.249409,
    width: 163.506,
    height: 163.506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20.2518,
    dy: 27.0024
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8765
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_691_1714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_691_1714",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_1714",
    x1: 91.8778,
    y1: 92.5611,
    x2: 32.1179,
    y2: 17.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_691_1714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.5688,
    height: 72.4871,
    fill: "white",
    transform: "translate(25.3633 19.0469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard6);
export default __webpack_public_path__ + "static/media/card6.61efedc57125a4e8d72e35f9dedb03de.svg";
export { ForwardRef as ReactComponent };